import React from 'react';

import Navbar from '~/components/modules/navigation/navbar';

const Header = ({
	location,
	hasNavigation,
	sectionTitle,
	sectionUrl,
	showToolkitsLabel,
	navbar
}) => {
	return (
		<header className="bg-white">
			{navbar ?
				navbar
				:
				<Navbar
					location={location}
					hasNavigation={hasNavigation}
					sectionTitle={sectionTitle}
					sectionUrl={sectionUrl}
					showToolkitsLabel={showToolkitsLabel}
				/>
			}
		</header>
	);
};

export default Header;
